import React from "react";
import Chip from "@mui/material/Chip";
import { FonepayWsStatus } from "../../../../../hooks/useFonePayWSS";

interface FonepayWebSocketStatusProps {
  status: FonepayWsStatus;
}

const statusMap: Record<
  FonepayWsStatus,
  { label: string; color: "default" | "primary" | "success" | "error" | "warning" | "info" }
> = {
  IDLE: { label: "Idle", color: "default" },
  DISCONNECTED: { label: "Disconnected", color: "default" },
  CONNECTING: { label: "Connecting", color: "warning" },
  CONNECTED: { label: "Connected", color: "success" },
  ERROR: { label: "Error", color: "error" }
};

const FonepayWebSocketStatus: React.FC<FonepayWebSocketStatusProps> = ({ status }) => {
  const { label, color } = statusMap[status] ?? {
    label: "Unknown",
    color: "default" as const
  };

  return <Chip label={label} color={color} size="small" />;
};

export default FonepayWebSocketStatus;
